import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';
import BallsLoader from "./BallsLoader";

import {
  BadgeCc,
  BadgeCcFill,
  Fullscreen,
  FullscreenExit,
  VolumeOff,
  VolumeUp
} from "react-bootstrap-icons";
import initAdsAutoplay from "./initAdsAutoplay";

import styles from './styles.scss';
import {Helmet} from "react-helmet";

let defaultState = {
  url: null,
  paused: true,
  play: false,
  playing: true,
  ready: false,
  showAds: false,
  alreadyShowAd: false,
  muted: true,
  subtitles: false,
  hasSubtitles: false,
  volume: 0,
  controls: true,
  width: '100%',
  height: '100%',
  fullscreen: false,
  adsAreReproduced: 0,
  adsNumber: 0,
  vastLinks: null,
  logo: null,
  type: 'hls',
  disabledCookie: false,
  subUrl: null,
};

const LOGO_EXT = '#EXT-X-LOGO:';

export const createShowferPlayer = () => {

  return class ShowferPlayer extends Component {
    timer = null;

    static propTypes = {
      url: PropTypes.string.isRequired,
      width: PropTypes.string,
      height: PropTypes.string,
      controls: PropTypes.bool,
      volume: PropTypes.number,
      onReady: PropTypes.func,
      onPlay: PropTypes.func,
      onStart: PropTypes.func,
      type: PropTypes.string,
      disabledCookie: PropTypes.bool,
      muted: PropTypes.bool,
      subUrl: PropTypes.string,
      fullscreenFunc: PropTypes.func,
      fullscreen: PropTypes.bool,
      controlFunc: PropTypes.func,
      volumeFunc: PropTypes.func
    };

    state = {
      ...defaultState,
      url: this.props.url,
      width: this.props.width ?? defaultState.width,
      height: this.props.height ?? defaultState.height,
      controls: this.props.controls ?? defaultState.controls,
      volume: this.props.volume ?? defaultState.volume,
      type: this.props.type ?? defaultState.type,
      subUrl: this.props.subUrl ?? defaultState.subUrl,
      disabledCookie: this.props.disabledCookie ?? defaultState.disabledCookie,
      muted: this.props.muted ?? defaultState.muted,
    };

    constructor(props) {
      super(props);
      this.mainRef = React.createRef();
    }

    componentDidMount() {
      let self = this;

      fetch('https://api.airy.tv/api/v2.1.7/ads/web')
        .then((response) => {
          if (!response.ok) {
            throw new Error('Error occurred!')
          }

          return response.json();
        })
        .then((data) => {
          self.setState({ 'ima': data.response.ima, 'vast': data.response.options.vast });

          const timer = data.response.options.vast?.timer_vod?.interval ?? 0;
          if (timer > 0 && self.type !== 'hls') {
            // TODO: stop player
            self.timer = setTimeout(() => this.showAdByCueTones(), timer * 1000)
          }
        })
        .catch((err) => console.log(err));
    }

    componentWillUnmount() {
      clearTimeout(this.timer);
    }

    componentDidUpdate(props) {
      if (props.url !== this.props.url) {
        this.updatePlayerProps(this.props.url);
      }

      if (props.volume !== this.props.volume) {
        this.setState({
          ...this.state,
          volume: this.props.volume / 100,
          muted: this.props.volume === 0,
        })
      }


      if(this.props.type !== this.state.type) {
        this.setState({
          ...this.state,
          type: this.props.type,
        })
      }

      if(this.props.controls !== this.state.controls) {
        this.setState({
          ...this.state,
          controls: this.props.controls,
        })
      }

      if(this.props.subUrl !== this.state.subUrl) {
        this.setState({
          ...this.state,
          subUrl: this.props.subUrl,
        })
      }

      if(this.props.fullscreen !== this.state.fullscreen) {
        this.setState({
          ...this.state,
          fullscreen: this.props.fullscreen,
        })
      }

      if (this.player) {
        let hlsPlayer = this.player.getInternalPlayer('hls');

        if(hlsPlayer) {

          if(hlsPlayer.subtitleTracks?.length > 0) {
            if(this.state.hasSubtitles !== true) {
              this.setState({
                ...this.state,
                hasSubtitles: true,
              })
            }
          } else {
            if(this.state.hasSubtitles !== false) {
              this.setState({
                ...this.state,
                hasSubtitles: false,
              })
            }
          }

          if(this.state.subtitles === true) {
            hlsPlayer.subtitleDisplay = true;
            hlsPlayer.subtitleTrack = 0;
          } else {
            hlsPlayer.subtitleDisplay = false;
            hlsPlayer.subtitleTrack = -1;
          }
        }


      }

    }

    getInternalPlayer = (key = 'player') => {
      if (!this.player) {
        return null;
      }
      return this.player.getInternalPlayer(key)
    }

    updatePlayerProps = ( url ) => {
      this.setState({
        ...this.state,
        url: '',
        logo: null,
        playing: false,
        alreadyShowAd: false,
      });

      let hlsPlayer = this.player.getInternalPlayer('hls');
      if (hlsPlayer) {

        setTimeout(() => {
          hlsPlayer.stopLoad();
          this.setState({ url: url, playing: true });
        }, 0);
      } else {
        this.setState({ url: url, playing: true });
      }
    };

    bindPlayer = (player) => {
      this.player = player;
    };

    onReady = () => {
      if (this.props.onReady) {
        this.props.onReady();
      }
      this.setState({ ready: true, paused: false });
    }

    onStart = () => {
      if (this.props.onStart) {
        this.props.onStart();
      }
      if (this.state.showAds) {
        this.setState({ playing: false })
      }
    }

    onPlay = () => {
      if (this.props.onPlay) {
        this.props.onPlay();
      }

      this.setState({
        paused: false,
        play: true,
        firstPlay: false
      });
    };

    onProgress = () => {
      let self = this;

      if (this.player) {
        let hlsPlayer = this.player.getInternalPlayer('hls');
        if (hlsPlayer) {
          let level = hlsPlayer.levels[hlsPlayer.currentLevel];
          if (level && level.details) {
            let rows = level.details.m3u8.split('\n');
            rows.forEach((row) => {
              if (row.includes(LOGO_EXT)) {
                self.setState({ logo: row.substring(LOGO_EXT.length) });
              }
            })

            let tagList = level.details.fragments[0].tagList;
            tagList.forEach((tag) => {
              if (!self.state.showAds && !self.state.alreadyShowAd) {
                if (tag.includes('EXT-X-CUE-OUT')) {
                  this.showAdByCueTones();
                }

                if (tag.includes('EXT-X-CUE-OUT-CONT')) {
                  let durationData = tag[1].split('/');
                  let passedTime = parseFloat(durationData[0]);
                  let totalTime = parseFloat(durationData[1]);
                  let timeLeft = totalTime - passedTime;
                  if (timeLeft > 30) {
                    this.showAdByCueTones();
                  }
                }
              }

              if (tag.includes('EXT-X-CUE-IN')) {
                this.setState({ alreadyShowAd: false });
              }
            });
          }
        }
      }
    };

    onError = () => {
      if (!this.state.url) {
        return null;
      }

      this.setState({ error: true });
    }

    showAdByCueTones = () => {
      const cueTunesInfo = this.state.vast && this.state.vast.hasOwnProperty('cue_tones')
        ? this.state.vast['cue_tones']
        : null;
      const vodInfo = this.state.vast && this.state.vast.hasOwnProperty('timer_vod')
        ? this.state.vast['timer_vod']
        : null;
      const imaPayload = this.state.ima && this.state.ima.hasOwnProperty('publisherdesk.ima')
        ? this.linkConverting(this.state.ima['publisherdesk.ima'].payload)
        : null;

      if (imaPayload) {
        const adsNumber = this.state.type === 'hls' ?
            cueTunesInfo ? cueTunesInfo['number_ads'] : 0 :
            vodInfo ? vodInfo['number_ads'] : 0;
        const vastList = new Array(adsNumber).fill(imaPayload)
        this.showVastHandler(vastList)
      }
    }

    showVastHandler = (testUrls) => {
      let { muted } = this.state;
      const numberOfAds = testUrls.length;

      this.setState({
        showAds: true,
        alreadyShowAd: true,
        adsAreReproduced: this.state.adsAreReproduced + 1,
        vastLinks: testUrls,
        adsNumber: numberOfAds
      });

      setTimeout(() => {
        initAdsAutoplay(
          testUrls[this.state.adsAreReproduced - 1],
          this.onVastEnd,
          this.pauseHandler,
          muted === true,
            !this.state.disabledCookie
        );
      }, 0);
    }

    showVastOnlyHandler = (testUrls) => {
      let { muted } = this.state;
      this.setState({
        adsAreReproduced: this.state.adsAreReproduced + 1,
      });

      setTimeout(() => {
        initAdsAutoplay(
          testUrls[this.state.adsAreReproduced - 1],
          this.onVastEnd,
          this.pauseHandler,
          muted === true,
            !this.state.disabledCookie
        );
      }, 0);
    }

    onVastEnd = (adContainer) => {
      if (this.state.adsAreReproduced < this.state.adsNumber) {
        adContainer.removeChild(adContainer.firstChild)
        this.showVastOnlyHandler(this.state.vastLinks)
      } else {
        this.setState({
          showAds: false,
          playing: true,
          adsAreReproduced: 0
        })
      }
    }

    pauseHandler = () => {
      this.setState({ playing: false, showAds: true })
    }

    linkConverting = (adLink) => {
      if (!adLink) {
        return null
      }

      return decodeURIComponent(adLink);
    };

    toggleMuted = (e) => {
      e.preventDefault();
      if(this.props.volumeFunc) {
        this.props.volumeFunc();
      }
      this.setState({ muted: !this.state.muted, volume: !this.state.muted ? 0 : 1 });
    }

    toggleSubtitles = (e) => {
      e.preventDefault();
      this.setState({ subtitles: !this.state.subtitles });

    }



    toggleFullScreen = (e) => {
      e.preventDefault();
      if(this.props.fullscreenFunc) {
        return this.props.fullscreenFunc();
      } else {
        const container = this.mainRef.current;
        const fullscreenApi = container.requestFullscreen
            || container.webkitRequestFullScreen
            || container.mozRequestFullScreen
            || container.msRequestFullscreen;
        if (document && document.fullscreenElement) {
          this.setState({ fullscreen: false });

          return document.exitFullscreen();
        }

        this.setState({ fullscreen: true });

        return fullscreenApi.call(container);
      }

    }

    clickVideo = (e) => {
      e.preventDefault();
      if(this.props.controlFunc) {
        this.props.controlFunc();
      }
    }
    clickBottom = (e) => {
      e.preventDefault();
    }

    render() {
      let {
        url,
        width,
        height,
        play,
        muted,
        subtitles,
        hasSubtitles,
        volume,
        controls,
        fullscreen,
        showAds,
        playing,
        adsAreReproduced,
        adsNumber,
        logo,
        type,
        subUrl
      } = this.state;

      const shouldShowLoader = url && !play && !showAds;
      let file = {
        attributes: {
          crossOrigin: 'anonymous',
          onContextMenu: e => e.preventDefault(),
          controlsList: 'nodownload'
        },
        autoplay: true
      };
      if(subUrl && type !== 'hls') {
        file.tracks = [
          {
            kind: 'subtitles',
            src: subUrl,
            srcLang: 'en',
            label: "English",
            default: false
          }
        ];
      }

      return (
          <div ref={this.mainRef} id='player-component' style={{width: width, height: height}}>
            <Helmet>
              <script async={true} src={'//imasdk.googleapis.com/js/sdkloader/ima3.js'}/>
            </Helmet>
            <style>
              {styles}
            </style>
            <div className='ratio ratio-16x9' onClick={this.clickVideo}>
              {shouldShowLoader && (<BallsLoader/>)}
              {
                <React.Fragment>
                  <ReactPlayer
                      id='video-player'
                      url={url}
                      config={{file}}
                      width={'100%'}
                      height={'100%'}
                      playing={playing}
                      playsinline={false}
                      playbackRate={1}
                      onStart={this.onStart}
                      onReady={this.onReady}
                      onProgress={this.onProgress}
                      onPlay={this.onPlay}
                      onError={this.onError}
                      ref={this.bindPlayer}
                      volume={volume}
                      muted={muted}
                      controls={type !== 'hls'}
                  />
                  {logo &&
                      <div id="channel-logo" style={{backgroundImage: `url('${logo}')`}}/>
                  }
                </React.Fragment>
              }

              {showAds &&
                  <div id="adContainer" className="adContainer">
                    <div className="adContainer__counter">Ad {adsAreReproduced}/{adsNumber}</div>
                  </div>
              }
            </div>
            {controls &&
                <div id="bottom-overlay" onClick={this.clickBottom}>
                  <div>
                    {hasSubtitles &&
                        <button id="subtitles-btn" className={fullscreen ? "custom-fullscreen btn btn-outline-dark" : "btn btn-outline-dark"} onClick={this.toggleSubtitles}>
                          {subtitles &&
                              <BadgeCcFill/>
                          }
                          {!subtitles &&
                              <BadgeCc/>
                          }
                        </button>
                    }
                    <button id="mute-btn" className={fullscreen ? "custom-fullscreen btn btn-outline-dark" : "btn btn-outline-dark"} onClick={this.toggleMuted}>
                      {muted &&
                          <VolumeOff/>
                      }
                      {!muted &&
                          <VolumeUp/>
                      }
                    </button>
                    <button id="fullscreen-btn" className={fullscreen ? "custom-fullscreen btn btn-outline-dark" : "btn btn-outline-dark"} onClick={this.toggleFullScreen}>
                      {fullscreen &&
                          <FullscreenExit/>
                      }
                      {!fullscreen &&
                          <Fullscreen/>
                      }
                    </button>
                  </div>
                </div>
            }
          </div>
      )
    }
  }
}
